<template>
  <div class="container">
    <div class="img-block">
      <img src="img.png" />
    </div>
    <div class="download-block">
      <h3 class="block-title">Переход в чат</h3>
      <div>
        Перейти из мини-приложения в нативный чат по данному мини-приложению,
        если в нем есть чат
      </div>
      <AppButton block @click="goToChat">Перейти в чат</AppButton>
    </div>
    <div class="download-block">
      <h3 class="block-title">Переход к выбору тарифа подписки</h3>
      <div>Перейти из мини-приложения на экран выбора тарифа подписки</div>
      <AppButton block @click="goToPaywalls"
        >Перейти к тарифам подписок</AppButton
      >
    </div>
    <template v-if="Domyland.superApp.payload">
      <hr class="divider payload-top" />
      <h3 class="block-title payload">
        Payload: {{ Domyland.superApp.payload }}
      </h3>
      <hr class="divider" />
    </template>
    <div class="download-block">
      <h3 class="block-title">Скачивание и загрузка</h3>
      <div>Для теста скачается файл оферты</div>
      <AppButton block @click="downloadFile">Скачать файл</AppButton>
      <AppButton
        block
        type="secondary"
        @click="() => (fileInputElement as HTMLInputElement).click()"
      >
        Загрузить файл
      </AppButton>
      <input ref="fileInputElement" type="file" hidden @change="postFile" />
      <span
        v-if="!fileUploadResponse && !isFileUploadError"
        class="file-upload-result-label empty"
      >
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.5 8.5C2.5 5.46233 4.96233 3 8 3C11.0377 3 13.5 5.46233 13.5 8.5C13.5 11.5377 11.0377 14 8 14C4.96233 14 2.5 11.5377 2.5 8.5ZM8 1.5C4.1339 1.5 1 4.6339 1 8.5C1 12.3661 4.1339 15.5 8 15.5C11.8661 15.5 15 12.3661 15 8.5C15 4.6339 11.8661 1.5 8 1.5ZM7.03125 4.78125C7.03125 4.36704 7.36704 4.03125 7.78125 4.03125C8.19546 4.03125 8.53125 4.36704 8.53125 4.78125V8.30454C8.53125 8.37084 8.55759 8.43443 8.60447 8.48131L10.4991 10.3759C10.792 10.6688 10.792 11.1437 10.4991 11.4366C10.2062 11.7295 9.73131 11.7295 9.43842 11.4366L7.54381 9.54197C7.21562 9.21378 7.03125 8.76867 7.03125 8.30454V4.78125Z"
            fill="#18181A"
            fill-opacity="0.5"
          />
        </svg>
        Файл не загружен
      </span>
      <span
        v-else-if="isFileUploadError"
        class="file-upload-result-label error"
      >
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_55533_1168)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 8.5C0 4.0816 3.5816 0.5 8 0.5C12.4184 0.5 16 4.0816 16 8.5C16 12.9184 12.4184 16.5 8 16.5C3.5816 16.5 0 12.9184 0 8.5ZM11.7123 5.8522C12.0052 5.55931 12.0052 5.08444 11.7123 4.79154C11.4194 4.49865 10.9445 4.49865 10.6517 4.79154L8 7.44319L5.34835 4.79154C5.05546 4.49865 4.58058 4.49865 4.28769 4.79154C3.9948 5.08444 3.9948 5.55931 4.28769 5.8522L6.93934 8.50385L4.28769 11.1555C3.9948 11.4484 3.9948 11.9233 4.28769 12.2162C4.58058 12.5091 5.05546 12.5091 5.34835 12.2162L8 9.56451L10.6517 12.2162C10.9445 12.5091 11.4194 12.5091 11.7123 12.2162C12.0052 11.9233 12.0052 11.4484 11.7123 11.1555L9.06066 8.50385L11.7123 5.8522Z"
              fill="#FF3B30"
            />
          </g>
          <defs>
            <clipPath id="clip0_55533_1168">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
        Ошибка загрузки
      </span>
      <span
        v-else-if="fileUploadResponse && !isFileUploadError"
        class="file-upload-result-label success"
      >
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_55533_1208)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 8.5C0 4.0816 3.5816 0.5 8 0.5C12.4184 0.5 16 4.0816 16 8.5C16 12.9184 12.4184 16.5 8 16.5C3.5816 16.5 0 12.9184 0 8.5ZM5.33032 7.76967C5.03742 7.47678 4.56255 7.47678 4.26966 7.76967C3.97676 8.06256 3.97676 8.53744 4.26966 8.83033L6.86966 11.4303C7.16255 11.7232 7.63742 11.7232 7.93032 11.4303L12.3303 7.03033C12.6232 6.73744 12.6232 6.26256 12.3303 5.96967C12.0374 5.67678 11.5626 5.67678 11.2697 5.96967L7.39999 9.83934L5.33032 7.76967Z"
              fill="#34C759"
            />
          </g>
          <defs>
            <clipPath id="clip0_55533_1208">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
        Файл загружен
      </span>
    </div>
    <hr v-if="userInfoCells.length" class="divider" />
    <div v-if="userInfoCells.length" class="user-info-block">
      <h3 class="block-title user-info">Информация о пользователе</h3>
      <div v-if="isUserDataLoading" class="user-data-loading-label">
        Загрузка...
      </div>
      <template v-else>
        <div
          v-for="cell in userInfoCells"
          :key="cell.title"
          class="user-info-content-cell"
        >
          <div>{{ cell.title }}</div>
          <div>{{ cell.content }}</div>
        </div>
      </template>
    </div>
    <hr class="divider" />
    <div class="push-block">
      <h3 class="block-title push">Push-уведомления</h3>
      <div>Push придёт примерно через 5 секунд</div>
      <AppButton type="secondary" block @click="makePush">
        Получить push
      </AppButton>
    </div>
    <hr class="divider" />
    <div class="payment-block">
      <h3 class="block-title payment">
        Оплата
        <svg
          v-if="Domyland.miniApp.paymentStatus === 1"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="position: relative; top: 2px; margin-left: 4px"
        >
          <g clip-path="url(#clip0_55533_1208)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 8.5C0 4.0816 3.5816 0.5 8 0.5C12.4184 0.5 16 4.0816 16 8.5C16 12.9184 12.4184 16.5 8 16.5C3.5816 16.5 0 12.9184 0 8.5ZM5.33032 7.76967C5.03742 7.47678 4.56255 7.47678 4.26966 7.76967C3.97676 8.06256 3.97676 8.53744 4.26966 8.83033L6.86966 11.4303C7.16255 11.7232 7.63742 11.7232 7.93032 11.4303L12.3303 7.03033C12.6232 6.73744 12.6232 6.26256 12.3303 5.96967C12.0374 5.67678 11.5626 5.67678 11.2697 5.96967L7.39999 9.83934L5.33032 7.76967Z"
              fill="#34C759"
            />
          </g>
          <defs>
            <clipPath id="clip0_55533_1208">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
        <svg
          v-else-if="Domyland.miniApp.paymentStatus === 0"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="position: relative; top: 2px; margin-left: 4px"
        >
          <g clip-path="url(#clip0_55533_1168)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 8.5C0 4.0816 3.5816 0.5 8 0.5C12.4184 0.5 16 4.0816 16 8.5C16 12.9184 12.4184 16.5 8 16.5C3.5816 16.5 0 12.9184 0 8.5ZM11.7123 5.8522C12.0052 5.55931 12.0052 5.08444 11.7123 4.79154C11.4194 4.49865 10.9445 4.49865 10.6517 4.79154L8 7.44319L5.34835 4.79154C5.05546 4.49865 4.58058 4.49865 4.28769 4.79154C3.9948 5.08444 3.9948 5.55931 4.28769 5.8522L6.93934 8.50385L4.28769 11.1555C3.9948 11.4484 3.9948 11.9233 4.28769 12.2162C4.58058 12.5091 5.05546 12.5091 5.34835 12.2162L8 9.56451L10.6517 12.2162C10.9445 12.5091 11.4194 12.5091 11.7123 12.2162C12.0052 11.9233 12.0052 11.4484 11.7123 11.1555L9.06066 8.50385L11.7123 5.8522Z"
              fill="#FF3B30"
            />
          </g>
          <defs>
            <clipPath id="clip0_55533_1168">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </h3>
      <div>Произойдет переход на страницу оплаты</div>
      <div class="catalog">
        <div
          v-for="item in catalogItems"
          :key="item.title"
          class="catalog-item"
        >
          <img :src="item.img" width="80px" />
          <div class="content-wrapper">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-buy-action-content">
              <div class="item-price">{{ item.price }} ₽</div>
              <AppButton small @click="buyItem(item)">Купить</AppButton>
            </div>
          </div>
        </div>
      </div>
      <hr class="divider" />
    </div>
    <div class="payment-block">
      <h3 class="block-title push">Переход в тг</h3>
      <div class="text">Произойдет переход в тг</div>
      <div>
        <a href="https://t.me/domyland" class="block">
          <AppButton block> Открыть ТГ </AppButton>
        </a>
      </div>
    </div>
    <hr class="divider" />
  </div>
</template>

<script setup lang="ts">
import AppButton from "@/components/AppButton.vue";
import { onMounted, ref } from "vue";
import { Domyland } from "@domyland-shared/mini-app-sdk";

// refs
const fileInputElement = ref<HTMLInputElement | null>(null);

// data
const isFileUploadError = ref(false);
const fileUploadResponse = ref(false);
const userInfoCells = ref<Record<"title" | "content", string>[]>([]);
const isUserDataLoading = ref(false);
const catalogItems = [
  { title: "Цветы в горшке", price: "1100", img: "flowers-catalog.png" },
  { title: "Ноутбук", price: "700", img: "laptop.png" },
];

// methods
async function postFile(e?: InputEvent): Promise<void> {
  try {
    const files = (e?.target as HTMLInputElement).files;

    if (!files?.length) return;

    const file = files[0];
    const formData = new FormData();

    formData.set("file[]", file);

    const data = await fetch("https://uploads.domyland.com", {
      method: "POST",
      body: formData,
    });

    fileUploadResponse.value = (await data.json()).items[0].success;

    if (!fileUploadResponse.value) throw Error;

    isFileUploadError.value = false;
  } catch (e) {
    isFileUploadError.value = true;
  }
}

async function makePush(): Promise<void> {
  try {
    await Domyland.miniApp.sendDemoPush();
  } catch (e) {
    alert(e);
  }
}

async function buyItem(
  item: Record<"title" | "price" | "img", string | number>
): Promise<void> {
  await Domyland.miniApp.pay([
    { title: item.title as string, sum: Number(item.price), quantity: 1 },
  ]);
}

async function goToChat(): Promise<void> {
  try {
    await Domyland.superApp.chat();
  } catch (e) {
    alert(e);
  }
}

function goToPaywalls() {
  try {
    Domyland.superApp.redirect("paywall");
  } catch (e) {
    alert(e);
  }
}

const downloadFile = () => {
  const linkElement = document.createElement("a");

  linkElement.setAttribute("href", "laptop.png");
  linkElement.setAttribute("target", "_blank");
  linkElement.setAttribute("download", "test_image_file");

  linkElement.click();
};

const phoneFormat = (s: string, plus = true) => {
  const startsWith = plus ? "+7" : "8";

  let phone = s.replace(/[^0-9]/g, "");
  if (phone.startsWith("7") && plus) {
    phone = phone.substr(1);
  }
  if (phone.startsWith("8")) {
    phone = phone.substr(1);
  }

  return phone.replace(
    /(\d{3})(\d{3})(\d{2})(\d{2})/g,
    `${startsWith} ($1) $2 $3 $4`
  );
};

// hooks
onMounted(async () => {
  isUserDataLoading.value = true;

  const userData = (await Domyland.miniApp.userInfo([]))?.data;

  isUserDataLoading.value = false;

  if (userData?.roleId) {
    let roleTitle = "";

    switch (userData.roleId) {
      case 1:
        roleTitle = "Собственник";
        break;
      case 2:
        roleTitle = "Житель / член семьи";
        break;
      case 3:
        roleTitle = "Представитель собственника";
        break;
      case 4:
        roleTitle = "Арендатор";
        break;
    }

    userInfoCells.value.push({
      title: "Тип",
      content: roleTitle,
    });
  }

  if (userData?.lastName && userData?.firstName)
    userInfoCells.value.push({
      title: "ФИО",
      content: `${userData?.lastName} ${userData?.firstName}`,
    });

  if (userData?.age) {
    userInfoCells.value.push({ title: "Возраст", content: userData?.age });
  }

  if (userData?.phoneNumber)
    userInfoCells.value.push({
      title: "Телефон",
      content: phoneFormat(userData?.phoneNumber),
    });

  if (userData?.email) {
    userInfoCells.value.push({
      title: "Электронная почта",
      content: userData.email,
    });
  }

  if (userData?.sex) {
    userInfoCells.value.push({
      title: "Пол",
      content: userData.sex,
    });
  }

  if (userData?.place?.fullAddress) {
    userInfoCells.value.push({
      title: "Полный адрес",
      content: userData?.place?.fullAddress,
    });
  }
});
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");

body {
  font-family: "Roboto", sans-serif;
  padding: 0;
  margin: 0;
}

.block-title {
  font-size: 20px;
  font-weight: 600;

  &.payload {
    border: 1px solid #6029e5;
    border-radius: 12px;
    padding: 10px 13px;
  }
  &.user-info {
    margin-bottom: 8px;
  }
  &.push {
    margin-bottom: 4px;

    & + div {
      font-size: 14px;
      font-weight: 400;
      color: #18181ab2;
      margin-bottom: 20px;
    }
  }
  &.payment {
    margin-bottom: 4px;
    & + div {
      font-size: 14px;
      font-weight: 400;
      color: #18181ab2;
      margin-bottom: 8px;
    }
  }
}

.divider {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #f2f2f7;
  margin: 20px 0;
  padding: 0;

  &.payload-top {
    margin-top: 16px;
  }
}

.container {
  padding-left: 20px;
  padding-right: 20px;

  > .img-block {
    margin-top: 10px;

    > img {
      width: 100%;
    }

    > .close-button {
      margin-top: 12px;
    }
  }

  > .download-block {
    > h3 {
      margin-bottom: 12px;
    }

    > div {
      color: #18181ab2;
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 20px;
    }

    .app-button {
      margin-bottom: 16px;
    }

    .file-upload-result-label {
      > svg {
        margin-right: 4px;
        vertical-align: text-top;
      }

      &.empty {
        color: #18181a80;
      }
      &.error {
        color: #ff3b30;
      }
      &.success {
        color: #34c759;
      }
    }
  }

  > .user-info-block {
    > .user-info-content-cell {
      padding-top: 12px;
      padding-bottom: 12px;

      &:last-of-type {
        padding-bottom: 8px;
      }

      > div:first-of-type {
        font-size: 14px;
        color: #18181a80;
        margin-bottom: 2px;
      }

      > div:last-of-type {
        font-size: 16px;
        color: #18181a;
      }
    }
    > .user-data-loading-label {
      font-size: 14px;
      color: #18181a80;
    }
  }

  > .payment-block {
    > .catalog {
      > .catalog-item {
        align-items: center;
        display: flex;
        padding-top: 12px;
        padding-bottom: 12px;

        > .payment-content {
          align-items: end;
          display: flex;
        }

        > .content-wrapper {
          width: 100%;

          .item-title {
            margin-bottom: 9.5px;
          }

          .item-buy-action-content {
            align-items: center;
            display: flex;

            button {
              margin-left: auto;
            }

            .item-price {
              font-size: 16px;
              font-weight: 600;
            }
          }
        }

        img {
          margin-right: 12px;
        }
      }
    }
  }
}
a {
  text-decoration: none;
  color: #fff;
  width: 100%;
  display: block;
}
</style>
